import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/mid';
// errorDialog跳dialog , repeatRequestCancel可以重複請求
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 是否需要進行門號核實驗證
export function getNeedMIDVerify() {
    return get(`${url}/needMIDVerify`);
}

// 取得電話核實保單條款
export function getMidClause() {
    return get(`${url}/getClause`);
}

/**
 *進行門號核實驗證
 */
export function submitMidVerify() {
    return post(`${url}/verify`);
}

/**
 *取得填寫要保人/被保人與門號申辦人關係畫面資訊
 */
export function getMidRelationInfo() {
    return get(`${url}/relationInfo`);
}

/**
 *填寫要保人/被保人與門號申辦人關係
 */
export function postMidRelationInfo(data) {
    return post(`${url}/relationInfo`, data, { ...options, repeatRequestCancel: true });
}

/**
 * 雲端E櫃檯檢核新行動電話是否需要進行門號核實驗證
 */
export function postNeedCecMIDVerify(data) {
    return post(`${url}/needCecMIDVerify`, data, { ...options, repeatRequestCancel: true });
}

/**
 * 雲端E櫃檯新行動電話進行門號核實驗證
 */
export function postCecMIDVerify(data) {
    return post(`${url}/cecVerify`, data, { ...options, repeatRequestCancel: true });
}